import { PersonaCollectionContext } from '@sdk/personaCollection/PersonaCollectionContext';
import { AuthProvider } from '@sdk/authentication/AuthContext';

import UserDocumentsView from '@web/users/documents/UserDocumentsView/UserDocumentsView';

const UserDocumentsViewAngular = ({
  PersonaCollection,
  Authentication,
  user,
  documentId,
  setDocumentIdInPath,
  userManagers,
  disabled,
  disabledOnClick,
}) => {
  const isUserManagedByMe =
    Authentication.user.isAdmin ||
    userManagers.map((user) => user.id).includes(Authentication.user.id);

  return (
    <AuthProvider currentUser={Authentication.user}>
      <PersonaCollectionContext.Provider value={PersonaCollection}>
        <UserDocumentsView
          user={user}
          documentId={documentId}
          setDocumentIdInPath={setDocumentIdInPath}
          isUserManagedByMe={isUserManagedByMe}
          disabled={disabled}
          disabledOnClick={disabledOnClick}
        />
      </PersonaCollectionContext.Provider>
    </AuthProvider>
  );
};

export default {
  ReactComponent: UserDocumentsViewAngular,
  dependencies: ['PersonaCollection', 'Authentication'],
  bindings: {
    user: '<',
    documentId: '<',
    setDocumentIdInPath: '<',
    userManagers: '<',
    disabled: '<',
    disabledOnClick: '&',
  },
};
